import React from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const ColorIcon = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ width: "40px", height: "40px", viewBox: "0 0 40 40" }, props), /* @__PURE__ */ React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", { transform: "translate(-49.000000, -242.000000)" }, /* @__PURE__ */ React.createElement("g", { transform: "translate(49.000000, 242.000000)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { stroke: "currentColor", x: "0.5", y: "0.5", width: "39", height: "39", rx: "1" })), /* @__PURE__ */ React.createElement("g", { transform: "translate(6.000000, 6.000000)" }, /* @__PURE__ */ React.createElement("rect", { stroke: "currentColor", x: "0.5", y: "0.5", width: "27", height: "27" })))))));

export { ColorIcon };
//# sourceMappingURL=ColorIcon.js.map
